import { request } from "./transport";

export interface ConversationSummary {
  readonly id: number;
  readonly title: string;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface ChatMessage {
  readonly id: number;
  readonly conversation_id: number;
  readonly role: "user" | "assistant" | "system" | "tool";
  readonly content: string;
  readonly content_type: string;
  readonly position: number;
  readonly metadata: Record<string, unknown> | null;
  readonly created_at: string;
}

export interface CreateConversationResponse {
  readonly conversation_id: number;
  readonly message: ChatMessage;
  readonly status: "processing";
}

export interface ConversationDetail {
  readonly conversation_id: number;
  readonly title: string | null;
  readonly messages: ReadonlyArray<ChatMessage>;
}

// Streaming Guide chat. POST routes return 202 — the assistant reply
// arrives over UserChannel as `agent:chunk` deltas + a terminal
// `agent:message`. Top-level method names match the spread pattern
// of the other api modules (no namespace).
export const conversations = {
  listConversations: () =>
    request<ReadonlyArray<ConversationSummary>>("/conversations"),

  showConversation: (id: number) =>
    request<ConversationDetail>(`/conversations/${id}`),

  createConversation: (
    message: string,
    clientContext?: Record<string, unknown>,
  ) =>
    request<CreateConversationResponse>("/conversations", {
      method: "POST",
      body: JSON.stringify({ message, client_context: clientContext ?? null }),
    }),

  sendChatMessage: (
    id: number,
    message: string,
    clientContext?: Record<string, unknown>,
  ) =>
    request<CreateConversationResponse>(`/conversations/${id}/message`, {
      method: "POST",
      body: JSON.stringify({ message, client_context: clientContext ?? null }),
    }),

  destroyConversation: (id: number) =>
    request<void>(`/conversations/${id}`, { method: "DELETE" }),
};
